import FitmentLabel from '../fitment-label';
import styles from './fitment-title.module.scss';
import { CatIconInfo } from 'components/blocks-components';
import cx from 'classnames';

const FitmentTitle = ({
  modelText,
  equipmentFamilyText,
  serialNumberText,
  fitmentDisplayText,
  isFitmentMobile = false
}) => {
  return (
    <div className="cat-u-margin-left-sm">
      <div className="cat-u-display-flex cat-u-width-100">
        <p
          className={cx('my-1', {
            [styles['fitment__link--mobile']]: isFitmentMobile,
            [styles['fitment__link-title']]: !isFitmentMobile
          })}
        >
          {fitmentDisplayText}
        </p>

        {!isFitmentMobile && (
          <CatIconInfo
            className={`cat-u-margin-left-sm ${styles['fitment__link-info-icon']}`}
          />
        )}
      </div>

      {!isFitmentMobile && (
        <div className={`cat-u-width-100  ${styles['fitment-small']}`}>
          <FitmentLabel
            modelText={modelText}
            equipmentFamilyText={equipmentFamilyText}
            serialNumberText={serialNumberText}
            fitmentDisplayText={fitmentDisplayText}
          />
        </div>
      )}
    </div>
  );
};
export default FitmentTitle;
